
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Shield, CheckCircle, School, Building, Hotel, Trophy, Users, FileText, AlertTriangle, Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function OzelDenetimler() {
  const { t } = useTranslation();

  const specialAudits = [
    {
      icon: School,
      title: t('services.ozel.school'),
      description: 'Eğitim kurumlarında güvenlik standartlarının değerlendirilmesi ve iyileştirme önerileri',
      features: [
        'Fiziksel güvenlik değerlendirmesi',
        'Yangın güvenlik sistemleri',
        'Acil durum planları',
        'Öğrenci güvenlik protokolleri',
        'Personel güvenlik eğitimleri'
      ],
      image: 'https://public.readdy.ai/ai/img_res/e0a3d1a29bddcf2a0036bf81cf690229.jpg'
    },
    {
      icon: Building,
      title: t('services.ozel.green'),
      description: 'Sürdürülebilir bina standartlarına uygunluk değerlendirmesi ve sertifikasyon',
      features: [
        'Enerji verimliliği değerlendirmesi',
        'Su tasarrufu sistemleri',
        'Çevre dostu malzeme kullanımı',
        'İç hava kalitesi kontrolü',
        'Atık yönetimi sistemleri'
      ],
      image: 'https://readdy.ai/api/search-image?query=Green%20building%20certification%20with%20sustainable%20architecture%2C%20solar%20panels%2C%20energy%20efficient%20systems%2C%20LEED%20standards%2C%20environmental%20assessment%20tools&width=600&height=400&seq=25&orientation=landscape'
    },
    {
      icon: Hotel,
      title: t('services.ozel.hotel'),
      description: 'Otel ve konaklama tesislerinde kalite ve güvenlik standartları denetimi',
      features: [
        'Hizmet kalitesi değerlendirmesi',
        'Hijyen ve sanitasyon kontrolü',
        'Güvenlik sistemleri denetimi',
        'Müşteri memnuniyet analizi',
        'Personel eğitim programları'
      ],
      image: 'https://readdy.ai/api/search-image?query=Hotel%20audit%20inspection%20with%20professional%20evaluating%20hospitality%20service%20quality%2C%20hotel%20rooms%2C%20safety%20standards%2C%20customer%20service%20protocols&width=600&height=400&seq=26&orientation=landscape'
    },
    {
      icon: Trophy,
      title: t('services.ozel.sports'),
      description: 'Spor tesisleri ve etkinliklerinde güvenlik standartları değerlendirmesi',
      features: [
        'Tesis güvenlik kontrolü',
        'Ekipman güvenlik testleri',
        'Acil müdahale planları',
        'Seyirci güvenlik önlemleri',
        'Sporcu sağlık protokolleri'
      ],
      image: 'https://readdy.ai/api/search-image?query=Sports%20facility%20safety%20audit%20with%20inspector%20checking%20athletic%20equipment%2C%20stadium%20safety%20systems%2C%20emergency%20protocols%2C%20sports%20venue%20security&width=600&height=400&seq=27&orientation=landscape'
    }
  ];

  const auditProcess = [
    {
      step: '01',
      title: 'İhtiyaç Analizi',
      description: 'Özel denetim gereksinimlerinin belirlenmesi'
    },
    {
      step: '02',
      title: 'Denetim Planı',
      description: 'Kapsamlı denetim programının hazırlanması'
    },
    {
      step: '03',
      title: 'Sahada Denetim',
      description: 'Uzman ekip tarafından yerinde değerlendirme'
    },
    {
      step: '04',
      title: 'Risk Analizi',
      description: 'Tespit edilen risklerin analizi ve önceliklendirme'
    },
    {
      step: '05',
      title: 'Rapor ve Öneriler',
      description: 'Detaylı denetim raporu ve iyileştirme önerileri'
    },
    {
      step: '06',
      title: 'Takip Denetimi',
      description: 'Düzeltici faaliyetlerin takibi ve kontrolü'
    }
  ];

  const auditAreas = [
    {
      title: 'Güvenlik Denetimleri',
      description: 'Fiziksel güvenlik, yangın güvenliği ve acil durum hazırlığı',
      icon: Shield
    },
    {
      title: 'Kalite Denetimleri',
      description: 'Hizmet kalitesi, müşteri memnuniyeti ve süreç iyileştirme',
      icon: CheckCircle
    },
    {
      title: 'Uygunluk Denetimleri',
      description: 'Yasal gereklilikler ve standartlara uygunluk kontrolü',
      icon: FileText
    },
    {
      title: 'Risk Denetimleri',
      description: 'Risk değerlendirmesi ve yönetim sistemleri kontrolü',
      icon: AlertTriangle
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-24 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Special%20sector%20audits%20with%20professional%20inspector%20conducting%20specialized%20safety%20assessment%2C%20various%20facility%20types%2C%20comprehensive%20evaluation%20procedures&width=1920&height=800&seq=28&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h1 className="text-5xl font-bold mb-6">{t('services.ozel.title')}</h1>
              <p className="text-xl leading-relaxed">
                {t('services.ozel.description')}
              </p>
            </div>
          </div>
        </section>

        {/* Main Services */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Özel Denetim Hizmetlerimiz</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Sektörel uzmanlığımızla özelleştirilmiş denetim çözümleri sunuyoruz
              </p>
            </div>

            <div className="space-y-16">
              {specialAudits.map((audit, index) => (
                <div key={index} className={`flex flex-col lg:flex-row items-center gap-12 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                  <div className="lg:w-1/2">
                    <img 
                      src={audit.image} 
                      alt={audit.title}
                      className="w-full h-80 object-cover rounded-lg shadow-lg"
                    />
                  </div>
                  <div className="lg:w-1/2">
                    <div className="flex items-center mb-4">
                      <audit.icon className="w-8 h-8 text-red-600 mr-3" />
                      <h3 className="text-3xl font-bold text-gray-800">{audit.title}</h3>
                    </div>
                    <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                      {audit.description}
                    </p>
                    <ul className="space-y-3 mb-6">
                      {audit.features.map((feature, featureIndex) => (
                        <li key={featureIndex} className="flex items-start">
                          <CheckCircle className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors font-medium whitespace-nowrap cursor-pointer">
                      Denetim Talep Et
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Audit Areas */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Denetim Alanları</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Kapsamlı denetim yaklaşımımızla tüm kritik alanları değerlendiriyoruz
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {auditAreas.map((area, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <area.icon className="w-8 h-8 text-red-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{area.title}</h3>
                  <p className="text-gray-600">{area.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Audit Process */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Denetim Süreci</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Sistematik ve kapsamlı denetim sürecimizle güvenilir sonuçlar elde ediyoruz
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {auditProcess.map((step, index) => (
                <div key={index} className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-red-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                    {step.step}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Special Audits */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-800 mb-4">Neden Özel Denetimler?</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Sektörel uzmanlık ve özelleştirilmiş yaklaşımın avantajları
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Eye className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Sektörel Uzmanlık</h3>
                <p className="text-gray-600">Her sektörün özel gereksinimlerine uygun denetim</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Shield className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Risk Azaltma</h3>
                <p className="text-gray-600">Sektörel risklerin proaktif yönetimi</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Kalite Artışı</h3>
                <p className="text-gray-600">Hizmet ve operasyon kalitesinde iyileştirme</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="w-10 h-10 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">Güven Artışı</h3>
                <p className="text-gray-600">Paydaş güveninin güçlendirilmesi</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-red-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold mb-6">Özel Denetim Hizmetlerimizden Yararlanın</h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Sektörünüze özel denetim ihtiyaçlarınız için uzman ekibimizle iletişime geçin. 
              Güvenlik, kalite ve uygunluk standartlarınızı yükseltin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-red-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Denetim Talebi
              </button>
              <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white hover:text-red-600 transition-colors whitespace-nowrap cursor-pointer">
                Sektörel Bilgi Al
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
